<template>
  <div class="company-news-background">
    <div class="company-news-banner">
      <div class="company-news-container">
        <div class="company-news-banner-title">{{ $t("companynew.news") }}</div>
      </div>

      <img class="company-news-banner-img" src="../../assets/about/banner.png">
    </div>
    <div class="company-news-container">

     <div class="company-news-content">

       <div class="company-news-line"></div>

       <div class="company-news-list" v-for="news in companyNewsList.data">

         <div class="company-news-list-content">

           <div class="company-news-list-img">
             <img class="company-news-list-img" v-show="news.img_url" @click="toCompanyNewsContent(news.id)" :src="CMS_API_NEWS_IMG+news.img_url">
           </div>

           <div class="company-news-list-time">
             <div class="company-news-list-time-month" v-show="news.time">{{news.time && news.time.substring(5)}}</div>
             <div class="company-news-list-time-year" v-show="news.time">{{news.time && news.time.substring(0,4)}}</div>
           </div>

           <div class="company-news-list-title">
             <div class="company-news-list-title-text" v-show="news.title" @click="toCompanyNewsContent(news.id)">{{news.title ? (news.title.length < 32 ? news.title : news.title.substring(0,32)+"...") : ''}}</div>
             <div class="company-news-list-summary" v-show="news.summary" @click="toCompanyNewsContent(news.id)">{{news.summary ? (news.summary.length < 110 ? news.summary : news.summary.substring(0,110)+"......") : ''}}</div>
           </div>

           <div class="company-news-list-right-btn">
             <img class="company-news-list-right-btn-img" src="../../assets/news/home_right_hui@2x.png" @click="toCompanyNewsContent(news.id)">
           </div>

         </div>

         <div class="company-news-line"></div>

       </div>

     </div>


      <nav class="company-news-page" aria-label="Page navigation example ">
        <ul class="pagination justify-content-center">
          <li class="page-item">
            <a class="page-link" :href="currentPage === 1 ? currentPage : currentPage-1" aria-label="Previous">
              <span aria-hidden="true">&laquo;</span>
              <span class="sr-only">Previous</span>
            </a>
          </li>
          <li class="page-item" v-for="(pageNum,index) in page"><a class="page-link" :href="index+1">{{index+1}}</a></li>
          <li class="page-item">
            <a class="page-link" :href="currentPage === lastPage ? currentPage : currentPage+1" aria-label="Next">
              <span aria-hidden="true">&raquo;</span>
              <span class="sr-only">Next</span>
            </a>
          </li>
        </ul>
      </nav>

    </div>
  </div>
</template>

<script>
  import {mapState} from 'vuex'
  import {CMS_API_NEWS_IMG} from '../../helpers/consts'
  export default {
    name: "companyIntroduce",
    data() {
      return {
        CMS_API_NEWS_IMG,
        currentPage:'',
        lastPage:'',
        page:''
      }
    },
    computed: {
      ...mapState({
        companyNewsList: state => state.CompanyNews.companyNewsList.info,
      })
    },
    watch: {
      // 如果路由有变化，会再次执行该方法
      "$route": "getCompanyNewsList"
    },
    created(){
      this.getCompanyNewsList()
    },
    methods:{
      getCompanyNewsList() {
        this.currentPage = parseInt(this.$route.params.page)
        this.$store.dispatch('getCompanyNewsList', this.$route.params.page).then(res => {
          //console.log(this.companyNewsList)
          this.lastPage = parseInt(this.companyNewsList.last_page)
          this.page = new Array(this.lastPage)
          //console.log(this.page)
        })
      },
      toCompanyNewsContent($id){
        this.$router.push({ name: 'CompanyNewsContent',params: {id:$id}})
      }

    }
  }
</script>

<style scoped>
  .company-news-container {
    width: 100%;
    padding-right: 15px;
    padding-left: 15px;
    margin-right: auto;
    margin-left: auto;
  }
  .company-news-background{
    margin-top: 70px;
  }
  .company-news-banner{
    overflow:hidden;
  }
  .company-news-banner-title{
    font-size:24px;
    font-family:PingFangSC-Semibold,sans-serif;
    font-weight:600;
    color:rgba(255,255,255,1);
    line-height:50px;
    position: absolute;
    margin-top: 60px;
  }
  .company-news-banner-img{
    min-width:100%;
    height:165px;
  }
  .company-news-content{
    margin-top: 85px;
    margin-bottom: 0;
  }
  .company-news-content-title{
    padding-top: 50px;
    text-align: center;
  }
  .company-news-content-title-text{
    font-size:30px;
    font-family:PingFangSC-Medium,sans-serif;
    font-weight:500;
    color:rgba(73,145,201,1);
    line-height:50px;
  }
  .company-news-line{
    width: 100%;
    height:1px;
    background:rgba(0,0,0,1);
    opacity:0.1;
  }
  .company-news-list-content{
    padding: 32px 0;
  }
  .company-news-list-img{
    width: 240px;
    height: 110px;
    display: inline-block;
    cursor: pointer;
  }
  .company-news-list-time{
    margin-left: 30px;
    display: inline-block;
    vertical-align: top;
  }
  .company-news-list-time-month{
    font-size:20px;
    font-family:PingFangSC-Light,sans-serif;
    font-weight:300;
    color:rgba(79,76,77,1);
    line-height:28px;
  }
  .company-news-list-time-year{
    font-size:14px;
    font-family:PingFangSC-Light,sans-serif;
    font-weight:300;
    color:rgba(79,76,77,1);
    line-height:20px;
  }
  .company-news-list-title{
    width: 570px;
    margin-left: 58px;
    margin-top: 8px;
    display: inline-block;
    vertical-align: top;
  }
  .company-news-list-title-text{
    font-size:16px;
    font-family:PingFangSC-Medium,sans-serif;
    font-weight:500;
    color:rgba(79,76,77,1);
    line-height:22px;
    cursor: pointer;
  }
  .company-news-list-title-text:hover,
  .company-news-list-title-text:active{
    color:rgba(73,145,201,1);
  }
  .company-news-list-summary{
    margin-top: 16px;
    font-size:14px;
    font-family:PingFangSC-Regular,sans-serif;
    font-weight:400;
    color:rgba(79,76,77,1);
    line-height:20px;
    cursor: pointer;
  }
  .company-news-list-right-btn{
    margin-left: 40px;
    margin-top: 32px;
    width: 32px;
    height: 32px;
    display: inline-block;
    vertical-align: top;
    float: right;
  }
  .company-news-list-right-btn-img{
    width: 32px;
    height: 32px;
    cursor: pointer;
  }
  .company-news-page{
    margin-top: 48px;
    margin-bottom: 48px;
  }
  @media screen and (max-width:482px) {
    .company-news-container{
      max-width: 100%;
    }
    .company-news-list-time{
      display: block;
      margin-left: 0;
      margin-top: 16px;
    }
    .company-news-list-title{
      width: 100%;
      margin-left: 0;
      margin-top: 16px;
      display: block;
    }
    .company-news-list-right-btn{
      display: none;
    }
    .company-news-list-img{
      width: 100%;
      height: unset;
    }
  }
  @media screen and (min-width:482px) and (max-width:768px) {
    .company-news-container{
      max-width: 450px;
    }
    .company-news-list-time{
      display: block;
      margin-left: 0;
      margin-top: 16px;
    }
    .company-news-list-title{
      width: 100%;
      margin-left: 0;
      margin-top: 16px;
      display: block;
    }
    .company-news-list-right-btn{
      display: none;
    }
    .company-news-list-img{
      width: 100%;
      height: unset;
    }
  }
  @media screen and (min-width:768px) and (max-width:1100px) {
    .company-news-container{
      max-width: 736px;
    }
    .company-news-list-title{
      width: 288px;
      margin-left: 28px;
      margin-top: 0;
    }
    .company-news-list-right-btn{
      margin-left: 28px;
    }
  }
  @media screen and (min-width:1100px) and (max-width:1444px) {
    .company-news-container{
      max-width: 1068px;
    }
  }
  @media screen and (min-width:1444px) {
    .company-news-container{
      max-width: 1068px;
    }
  }

</style>